// extracted by mini-css-extract-plugin
export default {"building":"W3sAvatar_building__tEQY6","small":"W3sAvatar_small__wxb54","check_dark":"W3sAvatar_check_dark__ccNdt"};